import React, { Suspense, lazy } from 'react';
import ChartDisplay from './ChartDisplay';
import { resolveChartEngine } from './echarts/chartTypeRegistry';

const EChartsDisplay = lazy(() => import('./echarts/EChartsDisplay'));

const ChartRenderer = (props) => {
  const engine = resolveChartEngine(props.chart);

  if (engine === 'echarts') {
    return (
      <Suspense
        fallback={
          <div className="chart-display preview">
            <div className="chart-content">
              <div className="chart-container">
                <p className="text-muted p-3">Loading chart…</p>
              </div>
            </div>
          </div>
        }
      >
        <EChartsDisplay {...props} />
      </Suspense>
    );
  }

  return <ChartDisplay {...props} />;
};

export default ChartRenderer;
